export default __webpack_public_path__ + "static/media/Facebook-marketingimg1.646ca442.png";